import { NewsletterSplitTestErrorType } from 'modules/newsletters/split-test/types/newsletter-split-test-interface'

export const defaultNewsletterSplitTestSettingsErrors: NewsletterSplitTestErrorType['settings'] = {
  winnerType: [],
  durationInHours: [],
  emailRatio: [],
}
